<template>
  <el-container class="clues_manage">
    <el-header class="header-style">
      <el-divider content-position="left">线索梳理</el-divider>
      <el-row>
        <el-col :span="6">
          <el-input
            prefix-icon="el-icon-search search"
            v-model="highSearch.key_words"
            size="mini"
            @input="handleSearchChange"
            placeholder="输入客户姓名或线索编码搜索"
          />
        </el-col>
        <el-col :span="12" style="margin-left: 0.2rem">
          <el-select
            v-model="valueList"
            multiple
            filterable
            collapse-tags
            size="mini"
            style="width: 50%"
            placeholder="请选择"
            :popper-append-to-body="false"
            @change="handelColCange"
            @remove-tag="handelColRm"
          >
            <el-option
              v-for="(item, index) in col"
              :label="item.label"
              :value="index"
              :key="index"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-collapse @change="handleChangeHeight" accordion v-model="activeOpen">
        <el-collapse-item title="高级筛选" name="1">
          <div class="changeHeight m-tabs-content">
            <el-row type="flex">
              <el-col :span="2" class="tr m-label text_right">线索状态</el-col>
              <el-col :span="4">
                <el-select
                  multiple
                  collapse-tags
                  v-model="highSearch.status"
                  placeholder="请选择线索状态"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="跟踪中"></el-option>
                  <el-option :value="0" label="未认领"></el-option>
                  <el-option :value="4" label="成单待确认"></el-option>
                  <el-option :value="3" label="无法联系"></el-option>
                  <el-option :value="2" label="已成交"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right">群聊ID</el-col>
              <el-col :span="4">
                <el-input
                  @change="groupInput"
                  v-model="highSearch.group_chat_id"
                  size="mini"
                  placeholder="输入群聊ID"
                />
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right"
                >咨询分类</el-col
              >
              <el-col :span="4">
                <el-select
                  :filterable="true"
                  multiple
                  collapse-tags
                  v-model="highSearch.refer_cate"
                  placeholder="请选择咨询分类"
                  size="mini"
                  clearable
                >
                  <el-option
                    v-for="item in serverTypes"
                    :key="item.server_id"
                    :label="item.server_name"
                    :value="item.server_id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col :span="2" class="tr m-label text_right">客户意向</el-col>
              <el-col :span="4">
                <el-select
                  multiple
                  collapse-tags
                  v-model="highSearch.intention"
                  placeholder="请选择客户意向"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="A"></el-option>
                  <el-option :value="2" label="B"></el-option>
                  <el-option :value="3" label="C"></el-option>
                  <el-option :value="4" label="D"></el-option>
                  <el-option :value="5" label="E"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right"
                >选择园区</el-col
              >
              <el-col :span="4">
                <el-select
                  multiple
                  collapse-tags
                  v-model="highSearch.garden"
                  placeholder="请选择园区"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="上海园区"></el-option>
                  <el-option :value="2" label="南京园区"></el-option>
                  <el-option :value="3" label="徐州园区"></el-option>
                  <el-option :value="6" label="北京园区"></el-option>
                  <el-option :value="7" label="天津园区"></el-option>
                  <el-option :value="8" label="江苏园区"></el-option>
                  <el-option :value="9" label="浙江园区"></el-option>
                  <el-option :value="10" label="广东园区"></el-option>
                  <el-option :value="11" label="江西园区"></el-option>
                  <el-option :value="12" label="山东园区"></el-option>
                  <el-option :value="13" label="山西园区"></el-option>
                  <el-option :value="14" label="河南园区"></el-option>
                  <el-option :value="15" label="河北园区"></el-option>
                  <el-option :value="16" label="湖南园区"></el-option>
                  <el-option :value="17" label="湖北园区"></el-option>
                  <el-option :value="18" label="贵州园区"></el-option>
                  <el-option :value="19" label="陕西园区"></el-option>
                  <el-option :value="20" label="四川园区"></el-option>
                  <el-option :value="21" label="安徽园区"></el-option>
                  <el-option :value="4" label="其他园区"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right">负责人</el-col>
              <el-col :span="4">
                <el-select
                  :filterable="true"
                  multiple
                  collapse-tags
                  v-model="highSearch.uid"
                  placeholder="请选择负责人"
                  size="mini"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in ConversionPeople"
                    :key="index"
                    :label="item.username"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col :span="2" class="tr m-label text_right">录入时间</el-col>
              <el-col :span="4">
                <div>
                  <el-date-picker
                    v-model="value1"
                    type="daterange"
                    range-separator="至"
                    size="mini"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    @change="pickerDataChange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right"
                >最近联系时间</el-col
              >
              <el-col :span="4">
                <div>
                  <el-date-picker
                    v-model="highSearch.communicat_at"
                    type="daterange"
                    range-separator="至"
                    size="mini"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    @change="pickerDataChangeRecently"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptionsContact"
                  >
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right">IM人员</el-col>
              <el-col :span="4">
                <el-select
                  :filterable="true"
                  multiple
                  collapse-tags
                  v-model="highSearch.im_name"
                  placeholder="请选择IM人员"
                  size="mini"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in ConversionPeople"
                    :key="index"
                    :label="item.username"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col :span="2" class="tr m-label text_right">所属省市</el-col>
              <el-col :span="4">
                <el-cascader
                  ref="cascaderAddr"
                  v-model="value3"
                  placeholder="请选择城市"
                  filterable
                  :props="optionProps"
                  :options="options"
                  size="mini"
                  @change="handleChangeSearch"
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="6" :offset="3">
                <el-switch
                  style="height: 0.56rem"
                  v-model="value5"
                  :width="40"
                  @change="switchChange"
                  active-text="排除所选城市"
                >
                </el-switch>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right"
                >线索来源</el-col
              >
              <el-col :span="4">
                <el-select
                  multiple
                  collapse-tags
                  v-model="highSearch.input_type"
                  placeholder="请选择线索来源"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="IM套电"></el-option>
                  <el-option :value="2" label="下单未支付"></el-option>
                  <el-option :value="3" label="仅点快捷回复"></el-option>
                  <el-option :value="4" label="仅IM咨询"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col :span="24" style="text-align: center">
                <el-button type="primary" size="mini" @click="handleSearch"
                  >查询</el-button
                >
                <el-button type="danger" size="mini" @click="handleCloseSearch"
                  >清除</el-button
                >
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item title="数据统计" name="2">
          <el-row class="mb-10">
            <el-col :span="4" style="display: flex">
              <div class="level count_style">
                <span class="count" style="color: #5787ff">客户意向：</span>
              </div>
            </el-col>
            <el-col :span="14" style="display: flex">
              <div class="level_num count_style">
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >A：{{ intentionData.A }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >B：{{ intentionData.B }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >C：{{ intentionData.C }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >D：{{ intentionData.D }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 2rem; margin-left: 0.3rem"
                  >E：{{ intentionData.E }}</span
                >
              </div>
            </el-col>
            <el-col :span="6" class="search_position"></el-col>
          </el-row>
          <el-row class="mb-10">
            <el-col :span="4" style="display: flex">
              <div class="level count_style">
                <span class="count" style="color: #5787ff">线索总数：{{ cluesNum }}</span>
              </div>
            </el-col>
            <el-col :span="16" style="display: flex">
              <div class="level_num count_style">
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >IM套电：{{ vipData.person_get }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >今日领取：{{ vipData.today_get }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >今日联系：{{ vipData.today_communicat }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >今日转化：{{ vipData.today_success }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 3rem; margin-left: 0.3rem"
                  >今日转化率：{{ vipData.percentage }}</span
                >
              </div>
            </el-col>
            <el-col :span="4" class="search_position"></el-col>
          </el-row>
          <el-row class="mb-10">
            <el-col :span="4" style="display: flex">
              <div class="level count_style">
                <span class="count" style="color: #5787ff"></span>
              </div>
            </el-col>
            <el-col :span="16" style="display: flex">
              <div class="level_num count_style">
                <span class="count" style="display: inline-block; margin-left: 0.3rem"
                  >非今日领取联系：{{ NVipData.person_not_today_communicat }}</span
                >
                <span class="count" style="display: inline-block; margin-left: 0.3rem"
                  >非今日领取转化：{{ NVipData.person_not_today_get_success }}</span
                >
                <span class="count" style="display: inline-block; margin-left: 0.4rem"
                  >今日领取联系通话时长：{{ vipData.today_duration }}</span
                >
                <span class="count" style="display: inline-block; margin-left: 0.4rem"
                  >今日领取联系平均通话时长：{{ vipData.today_avg_duration }}</span
                >
              </div>
            </el-col>
            <el-col :span="4" class="search_position"></el-col>
          </el-row>
          <el-row class="mb-10">
            <el-col :span="4" style="display: flex">
              <div class="level count_style">
                <span class="count" style="color: #5787ff"></span>
              </div>
            </el-col>
            <el-col :span="16" style="display: flex">
              <div class="level_num count_style">
                <span class="count" style="display: inline-block; margin-left: 0.3rem"
                  >今日领取未联系：{{ vipData.today_never_communicat }}</span
                >
              </div>
            </el-col>
            <el-col :span="4" class="search_position"></el-col>
          </el-row>
          <el-row class="mb-10">
            <el-col :span="4" style="display: flex">
              <div class="level count_style" style="margin-right: 0.38rem">
                <el-dropdown @command="handleCommandCompanyAll">
                  <span style="color: #5787ff" class="el-dropdown-link count"
                    >{{ changeValue }} <i class="el-icon-arrow-down el-icon--right"></i
                    ><span> : {{ percentNum }}</span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="item.ids"
                      v-for="(item, index) in percentCompanyAll"
                      :key="index"
                      >{{ item.name }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-col>
            <el-col :span="14" style="display: flex">
              <div class="level_num count_style">
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >公司分配：{{ company_allot.allot_get }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >今日分配：{{ company_allot.allot_today_get }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >今日联系：{{ company_allot.allot_communicat }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 1.8rem; margin-left: 0.3rem"
                  >今日转化：{{ company_allot.allot_success }}</span
                >
                <span
                  class="count"
                  style="display: inline-block; width: 2rem; margin-left: 0.3rem"
                  >转化率：{{ company_allot.percentage }}</span
                >
              </div>
            </el-col>
          </el-row>
          <el-row class="mb-10">
            <el-col :span="4" style="display: flex">
              <div class="level count_style">
                <span class="count" style="color: #5787ff"></span>
              </div>
            </el-col>
            <el-col :span="16" style="display: flex">
              <div class="level_num count_style">
                <span class="count" style="display: inline-block; margin-left: 0.3rem"
                  >非今日分配联系：{{ NVipData.allot_not_today_communicat }}</span
                >
                <span class="count" style="display: inline-block; margin-left: 0.3rem"
                  >非今日分配转化：{{ NVipData.allot_not_today_get_success }}</span
                >
                <span class="count" style="display: inline-block; margin-left: 0.4rem"
                  >今日分配联系通话时长：{{ company_allot.allot_duration }}</span
                >
                <span class="count" style="display: inline-block; margin-left: 0.4rem"
                  >今日分配联系平均通话时长：{{ company_allot.allot_avg_duration }}</span
                >
              </div>
            </el-col>
            <el-col :span="4" class="search_position"></el-col>
          </el-row>
          <el-row class="mb-10">
            <el-col :span="4" style="display: flex">
              <div class="level count_style">
                <span class="count" style="color: #5787ff"></span>
              </div>
            </el-col>
            <el-col :span="16" style="display: flex">
              <div class="level_num count_style">
                <span class="count" style="display: inline-block; margin-left: 0.3rem"
                  >今日分配未联系：{{ company_allot.allot_never_communicat }}</span
                >
              </div>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-header>

    <el-main class="main-style">
      <el-table
      height="calc(100vh - 346px)"
      ref="clue_tease_table"
        v-if="!loadingStatus"
        :data="pageData"
        size="medium"
        border
        style="width: 100%"
      >
        <el-table-column v-if="true" fixed label="线索编码" width="150" prop="tag_code">
          <template slot-scope="scope">
            <div :style="scope.row.status !== 2 ? 'cursor: pointer;width: 100%' : ''">
              <span
                class="dot"
                @click="copyUrl(scope.row.tag_code)"
                style="margin-right: 0.1rem; display: inline-block; width: 65%"
                >{{ scope.row.tag_code }}</span
              >
              <i
                @click="handleSignStar(scope.$index, scope.row)"
                v-if="scope.row.status !== 2"
                class="el-icon-star-on"
                :style="{ color: scope.row.sign_at ? 'red' : '' }"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed label="负责人" prop="users.username"></el-table-column>
        <el-table-column
          class="el-status"
          fixed
          label="线索状态"
          prop="status"
          width="100"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.status !== 2" class="popover_span">
              <span
                class="el-position"
                :style="{ color: scope.row.status === 2 ? '#CCCCCC' : '' }"
              >
                <span
                  class="dot"
                  :style="{
                    background:
                      scope.row.status === 0
                        ? '#88D023'
                        : '' || scope.row.status === 1
                        ? '#88D023'
                        : '' || scope.row.status === 2
                        ? '#CCCCCC'
                        : '' || scope.row.status === 3
                        ? '#D02323'
                        : '' || scope.row.status === 4
                        ? '#FDB526'
                        : '',
                  }"
                ></span>
                {{
                  scope.row.status == 0
                    ? "未认领"
                    : "" || scope.row.status == 1
                    ? "跟踪中"
                    : "" || scope.row.status == 2
                    ? "已成交"
                    : "" || scope.row.status == 3
                    ? "无法联系"
                    : "" || scope.row.status == 4
                    ? "成单待确认"
                    : ""
                }}</span
              >
            </div>
            <el-popover
              v-if="scope.row.status === 2"
              @show="popoverMethods(scope)"
              placement="right"
              trigger="hover"
              width="280"
            >
              <div class="popoverList">
                <span style="margin-right: 0.2rem"
                  >派单时间：{{
                    scope.row.order_date ? scope.row.order_date : "无"
                  }}</span
                >
                <span>转化天数：{{ scope.row.convert_days }}</span>
              </div>
              <el-button style="padding: 0; border: 0" slot="reference">
                <div
                  class="popover_span"
                  :style="{ cursor: scope.row.status === 2 ? 'pointer' : '' }"
                >
                  <span
                    class="el-position"
                    :style="{ color: scope.row.status === 2 ? '#CCCCCC' : '' }"
                  >
                    <span
                      class="dot"
                      :style="{
                        background:
                          scope.row.status === 1
                            ? '#88D023'
                            : '' || scope.row.status === 2
                            ? '#CCCCCC'
                            : '' || scope.row.status === 3
                            ? '#D02323'
                            : '' || scope.row.status === 4
                            ? '#FDB526'
                            : '',
                      }"
                    ></span>
                    {{
                      scope.row.status == 1
                        ? "跟踪中"
                        : "" || scope.row.status == 2
                        ? "已成交"
                        : "" || scope.row.status == 3
                        ? "无法联系"
                        : "" || scope.row.status == 4
                        ? "成单待确认"
                        : ""
                    }}</span
                  >
                </div>
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="线索来源" width="120" prop="input_type"></el-table-column>
        <el-table-column fixed label="线索分数" width="80" prop="thread_score">
          <template slot-scope="scope">
            <div style="cursor: pointer; width: 100%">
              <span
                @click="CluesDetail(scope.row.thread_id)"
                class="dot"
                style="display: inline-block; color: rgb(87, 135, 255)"
                >{{ scope.row.thread_score }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="沟通次数"
          width="120"
          prop="communicat_times"
        ></el-table-column>
        <el-table-column
          sortable
          label="最近联系时间"
          width="160"
          prop="last_communticat_at"
        >
          <template slot-scope="scope">
            <el-popover placement="right" trigger="click" width="600">
              <div class="popoverList">
                <el-timeline>
                  <el-timeline-item
                    class="time_class"
                    v-if="activitiesShow.length"
                    v-for="(activity, index) in activitiesShow"
                    :key="index"
                    :icon="activity.icon"
                    :type="activity.type"
                    :color="activity.color"
                    :size="activity.size"
                  >
                    <span
                      style="color: #666666; display: inline-block; margin-bottom: 0.2rem"
                      >{{ activity.uname + "于" }}</span
                    >
                    <!-- <span style="color: #666666">{{ activity.created_time }}</span> -->
                    <date-formatter :date-value="activity.created_time"></date-formatter>
                    <span style="color: #666666">{{ activity.communicat_type }}</span>
                    <div class="time_right">
                      <span>{{ activity.communication_note }}</span>
                    </div>
                    <div class="time_right">
                      <el-link
                        class="handleLinkImg"
                        v-for="(items, indexs) in activity.preview"
                        :key="indexs"
                        @click="handleLinkImgS(indexs, index)"
                        type="primary"
                      >
                        {{ "图片" + (indexs + 1) }}
                      </el-link>
                    </div>
                  </el-timeline-item>
                  <div v-if="!activitiesShow.length">没有记录</div>
                </el-timeline>
              </div>
              <el-button
                style="padding: 0; border: 0"
                slot="reference"
                @click="enter(scope.row.thread_id)"
                >
                <!-- {{ scope.row.last_communicat_at }} -->
                <date-formatter :date-value="scope.row.last_communicat_at"></date-formatter>
                </el-button
              >
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          v-if="false"
          sortable
          label="创建时间"
          width="120"
          prop="created_at"
        >
          <template slot-scope="scope">
            <!-- <el-tooltip :content="scope.row.created_at" placement="top"> -->
              <span class="count_style" style="display: inherit">
              <!-- {{
                scope.row.created_at
              }} -->
              <date-formatter :date-value="scope.row.created_at"></date-formatter>
              </span>
            <!-- </el-tooltip> -->

          </template>
        </el-table-column>
        <el-table-column
          v-if="false"
          sortable
          label="领取时间"
          width="120"
          prop="get_thread_at"
        >
          <template slot-scope="scope">
            <!-- <el-tooltip :content="scope.row.get_thread_at" placement="top"> -->
              <span class="count_style" style="display: inherit">
              <!-- {{
                scope.row.get_thread_at
              }} -->
              <date-formatter :date-value="scope.row.get_thread_at"></date-formatter>
              </span>
            <!-- </el-tooltip> -->

          </template>
        </el-table-column>
        <el-table-column v-if="false" label="沟通时长" width="100" prop="call_duration">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.call_duration" placement="top">
              <span class="count_style">{{ scope.row.call_duration }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          v-if="false"
          sortable
          label="客户意向"
          prop="intention"
          width="120"
        >
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.intention" placement="top">
              <span class="count_style">{{ scope.row.intention }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          v-if="item.display"
          v-for="(item, index) in col"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="tableColumn(item.prop)"
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="item.prop === 'page_title'"
              :content="scope.row[item.prop] + ''"
              placement="top"
            >
              <span class="count_style" style="display: inherit">{{
                scope.row[item.prop]
              }}</span>
            </el-tooltip>
            <span v-else-if="item.prop === 'created_at'">
              <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
            </span>
            <span v-else-if="item.prop === 'get_thread_at'">
              <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
            </span>
            <div v-else>
              <span class="count_style" style="display: inherit">{{
                scope.row[item.prop]
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="咨询关键内容" prop="refer_content" width="120">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.refer_content" placement="top">
              <span class="count_style" style="display: inherit">{{
                scope.row.refer_content
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="60">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="沟通记录/线索历史"
              placement="top"
            >
              <el-button
                type="success"
                size="mini"
                icon="el-icon-time"
                @click="handleContactOpen(scope.$index, scope.row)"
                circle
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div v-else class="loading-placeholder">加载中，请稍后...</div>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        background
        class="tr mt-10"
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="search ? pageOption.currentPage2 : pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      title="沟通记录"
      :visible.sync="ContactDrawer"
      direction="rtl"
      :before-close="handleAddDrawerBeforeClose"
      size="40%"
    >
      <el-tabs
        style="padding: 0 0.2rem 0 0.4rem"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="沟通记录" name="first">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="24">
                <div class="block">
                  <el-timeline>
                    <el-timeline-item
                      class="time_class"
                      v-if="activities.length"
                      v-for="(activity, index) in activities"
                      :key="index"
                      :icon="activity.icon"
                      :type="activity.type"
                      :color="activity.color"
                      :size="activity.size"
                    >
                      <span
                        style="
                          color: #666666;
                          display: inline-block;
                          margin-bottom: 0.2rem;
                        "
                        >{{ activity.uname + "于" }}</span
                      >
                      <span style="color: #666666">{{ activity.created_time }}</span>
                      <span style="color: #666666">{{ activity.communicat_type }}</span>
                      <div class="time_right">
                        <span>{{ activity.communication_note }}</span>
                      </div>
                      <div class="time_right">
                        <el-link
                          class="handleLinkImg"
                          v-for="(items, indexs) in activity.preview"
                          :key="indexs"
                          @click="handleLinkImg(indexs, index)"
                          type="primary"
                        >
                          {{ "图片" + (indexs + 1) }}
                        </el-link>
                      </div>
                    </el-timeline-item>
                    <div v-if="!activities.length">没有记录</div>
                  </el-timeline>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="线索历史" name="second">
          <div class="blocka">
            <el-timeline>
              <el-timeline-item
                v-for="(OperationRecord, index) in OperationRecord"
                :key="index"
                :timestamp="OperationRecord.created_at"
                placement="top"
              >
                <el-card>
                  <p>{{ OperationRecord.operate }}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
    <el-dialog title="线索详情" width="80%" :visible.sync="dialogTableVisible">
      <div class="m-tabs-content">
        <div class="listClues public">
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.status ? '' : '#4d84fe' }"
              >客户状态：</span
            >{{ cluesData.status }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.custom_name ? '' : '#4d84fe' }"
              >客户姓名：</span
            >{{ cluesData.custom_name }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.custom_phone ? '' : '#4d84fe' }"
              >客户手机：</span
            >{{ cluesData.custom_phone }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.custom_sex ? '' : '#4d84fe' }"
              >客户性别：</span
            >{{ cluesData.custom_sex }}</span
          >
        </div>
        <div class="listClues public">
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.custom_city_name ? '' : '#4d84fe' }"
              >所属省份：</span
            >{{ cluesData.custom_city_name }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.phone_province ? '' : '#4d84fe' }"
              >手机省份：</span
            >{{ cluesData.phone_province }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.wechat_account ? '' : '#4d84fe' }"
              >微信账号：</span
            >{{ cluesData.wechat_account }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.group_chat_id ? '' : '#4d84fe' }"
              >群聊id：</span
            >{{ cluesData.group_chat_id }}</span
          >
        </div>
        <div class="listClues public">
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.custom_trait ? '' : '#4d84fe' }"
              >客户性格：</span
            >{{ cluesData.custom_trait }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.custom_type ? '' : '#4d84fe' }"
              >客户类型：</span
            >{{ cluesData.custom_type }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.custom_source ? '' : '#4d84fe' }"
              >客户来源：</span
            >{{ cluesData.custom_source }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.intention ? '' : '#4d84fe' }"
              >客户意向：</span
            >{{ cluesData.intention }}</span
          >
        </div>
        <div class="listClues public">
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.input_type ? '' : '#4d84fe' }"
              >线索类型：</span
            >{{ cluesData.input_type }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.tag_code ? '' : '#4d84fe' }"
              >线索编码：</span
            >{{ cluesData.tag_code }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.thread_score ? '' : '#4d84fe' }"
              >线索分数：</span
            >{{ cluesData.thread_score }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.thread_type ? '' : '#4d84fe' }"
              >录入类型：</span
            >{{ cluesData.thread_type }}</span
          >
        </div>
        <div class="listClues public">
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.page_title ? '' : '#4d84fe' }"
              >页面标题：</span
            >{{ cluesData.page_title }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.im_name ? '' : '#4d84fe' }"
              >im姓名：</span
            >{{ cluesData.im_name }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.garden ? '' : '#4d84fe' }"
              >所属园区：</span
            >{{ cluesData.garden }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.custom_industry ? '' : '#4d84fe' }"
              >主营行业：</span
            >{{ cluesData.custom_industry }}</span
          >
        </div>
        <div class="listClues public">
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.last_communicat_at ? '' : '#4d84fe' }"
              >最近联系时间：</span
            >{{ cluesData.last_communicat_at }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.call_duration ? '' : '#4d84fe' }"
              >最近沟通时长：</span
            >{{ cluesData.call_duration }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.communicat_times ? '' : '#4d84fe' }"
              >沟通次数：</span
            >{{ cluesData.communicat_times }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.communicat_return ? '' : '#4d84fe' }"
              >沟通反馈：</span
            >{{ cluesData.communicat_return }}</span
          >
        </div>
        <div class="listClues public">
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.username ? '' : '#4d84fe' }"
              >负责人：</span
            >{{ cluesData.username }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.created_at ? '' : '#4d84fe' }"
              >创建时间：</span
            >{{ cluesData.created_at }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.get_thread_at ? '' : '#4d84fe' }"
              >领取时间：</span
            >{{ cluesData.get_thread_at }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.updated_at ? '' : '#4d84fe' }"
              >修改时间：</span
            >{{ cluesData.updated_at }}</span
          >
        </div>
        <div class="listClues public">
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.refer_cate ? '' : '#4d84fe' }"
              >咨询分类：</span
            >{{ cluesData.refer_cate }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.refer_content ? '' : '#4d84fe' }"
              >咨询关键内容：</span
            >{{ cluesData.refer_content }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.is_special_industry ? '' : '#4d84fe' }"
              >是否为特殊行业：</span
            >{{ cluesData.is_special_industry }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.license ? '' : '#4d84fe' }"
              >许可证：</span
            >{{ cluesData.license }}</span
          >
        </div>
        <div class="listClues public">
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.custom_turnover ? '' : '#4d84fe' }"
              >客户年营业额：</span
            >{{ cluesData.custom_turnover }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.custom_staff ? '' : '#4d84fe' }"
              >客户员工数：</span
            >{{ cluesData.custom_staff }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.need_combo ? '' : '#4d84fe' }"
              >客户套餐需求：</span
            >{{ cluesData.need_combo }}</span
          >
          <span class="counts"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.remark ? '' : '#4d84fe' }"
              >备注：</span
            >{{ cluesData.remark }}</span
          >
        </div>
        <div class="listClues public">
          <span class="counts" style="width: 33.33%"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.not_need_cause ? '' : '#4d84fe' }"
              >套餐不需要的原因：</span
            >{{ cluesData.not_need_cause }}</span
          >
          <span class="counts" style="width: 33.33%"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.maybe_need_server ? '' : '#4d84fe' }"
              >客户可能需要的服务：</span
            >{{ cluesData.maybe_need_server }}</span
          >
          <span class="counts" style="width: 33.33%"
            ><span
              class="listCluesTitle"
              :style="{ color: cluesData.is_other_need ? '' : '#4d84fe' }"
              >是否涉及其他需求：</span
            >{{ cluesData.is_other_need }}</span
          >
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import DateFormatter from "common/DateFormatter";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import PhoneCom from "common/PhoneCom";

export default {
  name: "clues_tease",
  components: {DateFormatter, PhoneCom},
  data() {
    return {
      activeOpen: "",
      percentNum: "",
      percentCompanyAll: [
        {
          id: 1,
          ids: 0,
          name: "日均总转化率",
        },
        {
          id: 2,
          ids: 1,
          name: "周均总转化率",
        },
        {
          id: 3,
          ids: 2,
          name: "月均总转化率",
        },
      ],
      count: "",
      cluesNum: "",
      changeValue: "日均总转化率",
      vipData: "",
      NVipData: "",
      company_allot: "",
      cluesIndex: 0,
      CluesManage: [],
      OperationRecord: [],
      ContactDrawer: false,
      search: "",
      value1: [],
      valueList: [],
      value3: [],
      value5: false,
      options: [],
      ConversionPeople: [],
      activities: [],
      intentionData: {},
      loadingStatus: true,
      highSearch: {
        group_chat_id: "",
        refer_cate: "",
        custom_city_name: [],
        start_time: "",
        end_time: "",
        type: 0,
        status: "",
        communicat_at: [],
        uid: "",
        im_name: "",
        intention: "",
        garden: "",
        input_type: "",
        key_words: "",
      },
      optionProps: {
        value: "id",
        label: "Provincial",
        children: "son",
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        currentPage2: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      col: [
        {
          label: "客户姓名",
          prop: "custom_name",
          display: false,
        },
        {
          label: "所属省市",
          prop: "custom_city_name",
          display: false,
        },
        {
          label: "客户手机",
          prop: "custom_phone",
          display: false,
        },
        {
          label: "创建时间",
          prop: "created_at",
          display: false,
        },
        {
          label: "领取时间",
          prop: "get_thread_at",
          display: false,
        },
        {
          label: "沟通时长",
          prop: "call_duration",
          display: false,
        },
        {
          label: "客户意向",
          prop: "intention",
          display: false,
        },
        {
          label: "手机省份",
          prop: "phone_province",
          display: false,
        },
        {
          label: "微信号",
          prop: "wechat_account",
          display: false,
        },
        {
          label: "咨询分类",
          prop: "refer_cate",
          display: false,
        },
        {
          label: "群聊ID",
          prop: "group_chat_id",
          display: false,
        },
        {
          label: "页面标题",
          prop: "page_title",
          display: false,
        },
        {
          label: "IM人员",
          prop: "im_name",
          display: false,
        },
        {
          label: "园区",
          prop: "garden",
          display: false,
        },
      ],
      activeName: "first",
      serverTypes: [],
      GetServerTypes: [""],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [date, date]);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisWeek()[0], this.thisWeek()[1]]);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastWeek()[0], this.LastWeek()[1]]);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisMonth()[0], this.thisMonth()[1]]);
            },
          },
          {
            text: "上个月",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastMonth()[0], this.LastMonth()[1]]);
            },
          },
        ],
      },
      pickerOptionsContact: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [date, date]);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisWeek()[0], this.thisWeek()[1]]);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastWeek()[0], this.LastWeek()[1]]);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisMonth()[0], this.thisMonth()[1]]);
            },
          },
          {
            text: "上个月",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastMonth()[0], this.LastMonth()[1]]);
            },
          },
        ],
      },
      activitiesShow: [],
      dialogTableVisible: false,
      cluesData: [],
      pageData: [],
      searchChange: false,
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.highSearch) {
        str += "&" + key + "=" + this.highSearch[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  // watch: {
  //   search: function () {
  //     this.pageOption.total = this.search ? this.searchTotal() : this.CluesManage.length
  //     this.pageOption.currentPage2 = 1
  //   }
  // },
  methods: {
    popoverMethods(scope) {
      // console.log(scope.row)
    },
    mouseover(id) {
      // console.log(id)
    },
    handelSetValue(headers) {
      if (headers.length > 0) {
        this.valueList = headers;
        return;
      }
      for (var i = 0; i <= this.col.length; i++) {
        this.valueList.push(i);
      }
    },
    handelColCange(val) {
      this.$axios
        .post("/api/thread/set_field", { fields: val, field_type: 1 })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.handelSetCol();
            setTimeout(() => {
              this.$refs.clue_tease_table.doLayout();
            }, 100);
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelSetCol() {
      for (var i = 0; i < this.col.length; i++) {
        if (this.valueList.indexOf(i) !== -1) {
          this.col[i].display = true;
        } else {
          this.col[i].display = false;
        }
      }
    },
    handelColRm(val) {
      console.log(val);
    },
    enter(id) {
      this.$axios.get("/api/thread/five_communicat_list/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.handleForMethodsShow(id, data.data);
          console.log(data.data);
          // this.$message.success(data.msg)
        } else {
          // this.$message.error(data.msg)
        }
      });
    },
    CluesDetail(id) {
      this.$axios.get("/api/thread/detail/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.dialogTableVisible = true;
          this.cluesData = data.data;
          // this.$message.success(data.msg)
        } else {
          // this.$message.error(data.msg)
        }
      });
    },
    handleLinkImgS(indexs, index) {
      var tempwindow = window.open("_blank");
      tempwindow.location = this.activitiesShow[index].preview[indexs];
    },
    handleForMethodsShow(id, data) {
      for (var i = 0; i < this.pageData.length; i++) {
        if (id === this.pageData[i].thread_id) {
          this.activitiesShow = data;

          for (var a = 0; a < this.activitiesShow.length; a++) {
            if (this.activitiesShow[a].communicat_type === "电话联系") {
              this.activitiesShow[a].communicat_type =
                "通过 " +
                data[a].communicat_type +
                "与客户沟通了" +
                data[a].call_duration +
                "秒";
            } else {
              this.activitiesShow[a].communicat_type =
                "通过 " + data[a].communicat_type + "与客户进行了沟通";
            }
            if (data[a].communicat_img) {
              this.activitiesShow[a].preview = data[a].communicat_img.split(",");
            }
            this.activitiesShow[a].size = "large";
            this.activitiesShow[a].type = "primary";
            this.activitiesShow[a].icon = "el-icon-s-custom";
          }
        }
      }
    },
    copyUrl(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    handleSignStar(index, row) {
      if (row.sign_at) {
        return;
      }
      this.$axios.get("/api/thread/sign/" + row.thread_id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.handleForSignStarMethods(row.thread_id, data.data, row, index);
          this.pageData.splice(index, 1);
          this.pageData.unshift(row);
          // if (this.index === 0) this.prePage()
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleForSignStarMethods(id, data, row, index) {
      for (var a = 0; a < this.pageData.length; a++) {
        if (id === this.pageData[a].thread_id) {
          this.pageData[a].sign_at = data.sign_at;
        }
      }
    },
    getCluesAdvisoryType() {
      this.$axios.get("/api/servertype/list").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.serverTypes = data.data;
          for (var a = 0; a < data.data.length; a++) {
            this.GetServerTypes.push(data.data[a].server_name);
          }
        }
      });
    },
    tableColumn(prop) {
      let width = "";
      if (prop === "page_title") {
        width = 140;
      }
      if (prop === "custom_city_name") {
        width = 140;
      }
      if (prop === "wechat_account") {
        width = 140;
      }
      if (prop === "custom_phone") {
        width = 170;
      }
      if (prop === "refer_cate" || prop === "group_chat_id") {
        width = 120;
      }
      if (prop === "created_at" || prop === "get_thread_at") {
        width = 140;
      }
      return width;
    },
    provinceCityData() {
      this.$axios.get("/api/thread/cities").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          for (var a = 0; a < data.data.length; a++) {
            this.options.push(data.data[a]);
          }
        }
      });
    },
    handleContactOpen(index, row) {
      this.ContactDrawer = true;
      this.cluesIndex = index;
      this.getOperationRecord(row.thread_id);
      this.$axios.get("api/thread/communicatelist/" + row.thread_id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          console.log(data);
          this.handleForMethods(row.thread_id, data.data);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleLinkImg(indexs, index) {
      var tempwindow = window.open("_blank");
      tempwindow.location = this.activities[index].preview[indexs];
    },
    handleForMethods(id, data) {
      for (var i = 0; i < this.pageData.length; i++) {
        if (id === this.pageData[i].thread_id) {
          this.activities = data;
          for (var a = 0; a < this.activities.length; a++) {
            if (this.activities[a].communicat_type === 1) {
              this.activities[a].communicat_type =
                "通过 " +
                this.getFeedBack(data[a].communicat_type) +
                "与客户沟通了" +
                data[a].call_duration +
                "秒";
            } else {
              this.activities[a].communicat_type =
                "通过 " + this.getFeedBack(data[a].communicat_type) + "与客户进行了沟通";
            }
            if (data[a].communicat_img) {
              this.activities[a].preview = data[a].communicat_img.split(",");
            }
            this.activities[a].size = "large";
            this.activities[a].type = "primary";
            this.activities[a].icon = "el-icon-s-custom";
          }
        }
      }
    },
    getFeedBack(key) {
      let vipData = [
        " ",
        "电话联系",
        "手机短信",
        "发送快递",
        "微信交流",
        "见面拜谈",
        "公司洽谈",
        "优开平台",
      ];
      return vipData[key];
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleAddDrawerBeforeClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearAddData();
          done();
        })
        .catch((_) => {});
    },
    clearAddData() {
      this.activities = [];
      this.OperationRecord = [];
    },
    getOperationRecord(id) {
      this.$axios.get("/api/thread/operatelist/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          for (var a = 0; a < data.data.length; a++) {
            this.OperationRecord.push(data.data[a]);
          }
        }
      });
    },
    getVipCluesNum() {},
    handleCommandCompanyAll(command) {
      let that = this;
      that.changeValue = that.percentCompanyAll[command].name;
      that.$axios
        .get("/api/thread/day_week_month", {
          params: {
            dayWeekMonth: command,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            that.percentNum = isFinite(
              data.data.today_all_success / data.data.today_all_rows
            )
              ? ((data.data.today_all_success / data.data.today_all_rows) * 100).toFixed(
                  2
                ) + "%"
              : 0;
          }
        });
    },
    handelGetOrders() {
      let that = this;
      this.$axios
        .get(
          "/api/thread/manage_list?page=" +
            this.pageOption.currentPage +
            "&pageSize=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData = data.data.list.data;
            this.count = data.data.count;
            this.ConversionPeople = data.data.users;
            this.cluesNum = data.data.header.all_rows;
            this.vipData = data.data.header.person;
            this.NVipData = data.data.header.not_today_get;
            this.intentionData = data.data.intention;
            this.company_allot = data.data.header.allot;
            this.searchChange = false;
            this.handelSetValue(data.data.fields);
            this.handelSetCol();
            that.vipData.percentage = isFinite(
              data.data.header.person.today_success / data.data.header.person.today_get
            )
              ? (
                  (data.data.header.person.today_success /
                    data.data.header.person.today_get) *
                  100
                ).toFixed(2) + "%"
              : 0;
            that.company_allot.percentage = isFinite(
              data.data.header.allot.allot_success /
                data.data.header.allot.allot_today_get
            )
              ? (
                  (data.data.header.allot.allot_success /
                    data.data.header.allot.allot_today_get) *
                  100
                ).toFixed(2) + "%"
              : 0;
            that.percentNum = isFinite(
              data.data.header.today_all_success / data.data.header.today_all_rows
            )
              ? (
                  (data.data.header.today_all_success / data.data.header.today_all_rows) *
                  100
                ).toFixed(2) + "%"
              : 0;
            for (var a = 0; a < this.pageData.length; a++) {
              this.pageData[a].refer_cate = this.refer_cateMethods(
                this.pageData[a].refer_cate
              );
              this.pageData[a].input_type = this.clientSource(
                this.pageData[a].input_type
              );
              this.pageData[a].intention = this.clientIntention(
                this.pageData[a].intention
              );
              this.pageData[a].garden = this.gardenMethods(this.pageData[a].garden);
              if (this.pageData[a].custom_phone) {
                this.pageData[a].custom_phone = "*******";
              }
              if (this.pageData[a].wechat_account) {
                this.pageData[a].wechat_account = "*******";
              }
              if (this.pageData[a].group_chat_id) {
                this.pageData[a].group_chat_id = "*******";
              }
            }
            this.pageOption.total = data.data.list.total;
          }
        })
        .finally(() => {
          this.loadingStatus = false;
        })
        .catch((err) => {
          this.loadingStatus = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    gardenMethods(key) {
      let vipData = [" ", "上海园区", "南京园区", "徐州园区", "其他园区"];
      return vipData[key];
    },
    clientSource(key) {
      let vipData = [" ", "IM套电", "下单未支付", "仅点快捷回复", "仅IM咨询"];
      return vipData[key];
    },
    clientIntention(key) {
      let vipData = [" ", "A", "B", "C", "D", "E"];
      return vipData[key];
    },
    refer_cateMethods(key) {
      let vipData = this.GetServerTypes;
      return vipData[key];
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    searchTotal() {
      return this.CluesManage.filter(
        (data) =>
          !this.search ||
          (data.custom_name &&
            data.custom_name.toLowerCase().includes(this.search.toLowerCase())) ||
          (data.tag_code &&
            data.tag_code.toLowerCase().includes(this.search.toLowerCase()))
      ).length;
    },
    groupInput(val) {
      this.highSearch.group_chat_id = val;
    },
    pickerDataChange(val) {
      if (!val) {
        this.highSearch.start_time = [];
        this.highSearch.end_time = [];
      } else {
        this.highSearch.start_time = val[0];
        this.highSearch.end_time = val[1];
      }
    },
    pickerDataChangeRecently(val) {
      if (!val) {
        this.highSearch.communicat_at = "";
        this.highSearch.communicat_at = "";
      } else {
        this.highSearch.communicat_at[0] = val[0];
        this.highSearch.communicat_at[1] = val[1];
      }
    },
    handleChangeSearch(value) {
      // let input = this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels
      this.highSearch.custom_city_name[0] = value[0];
      this.highSearch.custom_city_name[1] = value[1];
    },
    switchChange(value) {
      this.highSearch.type = value ? 1 : 0;
    },
    handleSearch() {
      this.activeOpen = "";
      this.handelGetOrders();
    },
    handleCloseSearch() {
      this.highSearch.group_chat_id = "";
      this.highSearch.refer_cate = "";
      this.value3 = [];
      this.value = [];
      this.value1 = [];
      this.value5 = false;
      this.highSearch.status = "";
      this.highSearch.type = 0;
      this.highSearch.communicat_at = [];
      this.highSearch.input_type = "";
      this.highSearch.uid = "";
      this.highSearch.im_name = "";
      this.highSearch.intention = "";
      this.highSearch.garden = "";
      this.activeOpen = "";
      this.handelGetOrders();
    },
    handleChangeHeight(val) {},
    LastWeek() {
      const end = new Date();
      const start = new Date();
      const lastWeek = new Date().getDay(); // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)); // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek);
      return [start, end];
    },
    thisWeek() {
      var Nowdate = new Date();
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);

      var M = Number(WeekFirstDay.getMonth()) + 1;
      var start = WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
      var Mon = Number(WeekLastDay.getMonth()) + 1;
      var end = WeekLastDay.getFullYear() + "-" + Mon + "-" + WeekLastDay.getDate();

      return [start, end];
    },
    thisMonth() {
      const end = new Date();
      const start = new Date();
      // 方法1
      const endDay = new Date().getDate() - 1; // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay);
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end];
    },
    LastMonth() {
      const end = new Date();
      const start = new Date();
      const year = new Date().getFullYear(); // 获取年份
      let month = new Date().getMonth(); // 获取月份
      month = month === 0 ? 1 : month; // 特殊处理:如果为1月 则下方取1月的天数
      const febDays = year % 4 ? 29 : 28; // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 罗列12个月的天数
      start.setDate(1 - days[month - 1]); // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1); // 以此得出,本月1号 - 1天 = 上月最后一天
      return [start, end];
    },
    handleSearchChange() {
      if (this.searchChange) return;
      this.searchChange = true;
      setTimeout(() => {
        this.pageOption.currentPage = 1;
        this.handelGetOrders();
      }, 800);
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  mounted() {
    this.getCluesAdvisoryType();
    this.handelGetOrders();
    this.provinceCityData();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.public
  display flex
  width 100%
  box-sizing border-box
.clues_manage
  .popover_span
    .el-position
      font-family: Arial, "Microsoft Yahei", "Helvetica Neue", Helvetica, sans-serif;
  marginLeft()
  max-height: 100vh
  .header-style
    z-index: 2
    height: 174px !important
    padding: 0px !important
  .main-style
    z-index: 1
    padding: 0px !important
    // overflow-y: auto
  .footer-style
    text-align: right
    .el-pagination
      padding-top: 15px
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.tr
  text-align: right
.m-tabs-content
  overflow-y auto
  .listClues
    flex-direction row
    justify-content space-between
    margin-bottom .4rem
    .counts
      display inherit
      width 25%;
      line-height: .56rem;
      margin-right .2rem
      color: #000
      .listCluesTitle
        font-weight bold
  .m-label
    line-height: .64rem
  .text_right
    text-align left
  .el-row
    margin-bottom: .4rem
.clues_manage >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.mb-10
  margin-bottom: .2rem
  margin-top: 0.4rem;
.mt-10
  margin-top: .2rem
.level
  display flex
  align-items center
  position relative
  padding-right .32rem
  img
    width .32rem
    height .30rem
  .el-icon-question
    margin-left: .1rem
    color: #409EFF
    position absolute
    top 0
    right 0
    cursor pointer
.el-select, .el-cascader
  width: 100%
.count
  padding-left: .2rem
  line-height: .56rem
.el-position
  position relative
  .dot
    display inline-block
    width 0.1rem
    height 0.1rem
    border-radius 50%
    margin-right 0.1rem
    position absolute
    top 0
    left -.2rem
    bottom 0
    margin auto
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.changeHeight
  padding .2rem
  margin-top .4rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-collapse >>> .el-collapse-item__content
  padding-bottom 0
.el_dialogs >>> .el-dialog__body
  padding-left 0
  padding-right 0
.el_dialogs >>> .el-dialog__header
  padding 0

.block
  height 6rem
  overflow-y auto
  padding-top .2rem
  padding-left .2rem
  box-sizing border-box

  .time_right
    width 100%
    margin-top .4rem
    overflow hidden
    word-break break-all
    white-space normal
.handleLinkImg
  margin-right 0.2rem
.handleLinkImg:nth-last-child(1)
  margin-right 0
.el-timeline-item__node--large
  width .4rem
  height .4rem
/*滚动条整体样式*/
::-webkit-scrollbar{
  width: .1rem;/*竖向滚动条的宽度*/
  height: 10px;/*横向滚动条的高度*/
}
::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
  background: #cdcdcd;
  border-radius: 5px;
}
::-webkit-scrollbar-track{/*滚动条轨道的样式*/
  background: #f8f8f8;
  border-radius: 5px;
}
.el-date-editor
  width: 100% !important

.loading-placeholder {
  text-align: center;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/clues_tease/clues_tease.vue